module.exports = __webpack_public_path__ + "img/skqlogo.398d916d.png";